import { useTranslation } from "react-i18next";
import { dateTimeFormat } from "../../../../../utils/helpers/date";
import { useCompanyDateFormat, useCompanyTimeFormat } from "../../../../../utils/hooks/company";
import classNames from "classnames";
import { Tooltip } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClockRotateLeft } from "@fortawesome/free-solid-svg-icons";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

const HistoryTooltipComponent = ({ id, keysLength, visible, toggle, row, children }) => {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();
    const timeFormat = useCompanyTimeFormat();

    return (
        <span id={id}>
            <span
                className={classNames(keysLength > 0 && "cursor-pointer", "px-3 rounded py-2 text-info")}
                style={{ background: "#dfdaed" }}
            >
                {keysLength}
            </span>

            {keysLength > 0 && (
                <Tooltip
                    className="settings-history-tooltip"
                    target={id}
                    trigger="hover"
                    autohide={false}
                    isOpen={visible}
                    toggle={toggle}
                    placement="bottom"
                >
                    {row.original.action === "create" ? (
                        <div className="d-flex flex-column align-items-start justify-content-start">
                            <div className="clock-info position-relative d-flex align-items-center pb-1 pl-3 bg-white">
                                <FontAwesomeIcon className="text-lg" icon={faClockRotateLeft} />
                                <span className="text-sm mx-2">
                                    {dateTimeFormat(row.original.createdAt, `${dateFormat} ${timeFormat}`)}
                                </span>

                                <span className="px-3 py-1 rounded text-primary" style={{ background: "#ebebeb" }}>
                                    {t(row.original.action)}
                                </span>
                            </div>

                            <div className="my-3 ml-4 text-primary font-weight-bold">
                                {renderSettingsResourceLabel(row.original.data)}
                            </div>
                        </div>
                    ) : (
                        <>
                            <div
                                className="d-flex flex-column align-items-start justify-content-start px-3 m-3"
                                style={{ borderLeft: "1px dashed rgb(210, 209, 211)" }}
                            >
                                <div className="clock-info pt-3 pb-1 pl-3 bg-white">
                                    <FontAwesomeIcon className="text-lg" icon={faClockRotateLeft} />
                                    <span className="text-sm mx-2">
                                        {dateTimeFormat(row.original.createdAt, `${dateFormat} ${timeFormat}`)}
                                    </span>

                                    <span
                                        className="px-3 py-1 rounded text-primary"
                                        style={{ background: "#ebebeb" }}
                                    >
                                        {t(row.original.action)}
                                    </span>
                                </div>
                            </div>

                            {children}
                        </>
                    )}
                </Tooltip>
            )}
        </span>
    );
};

export default HistoryTooltipComponent;
